import { Switch, Route } from 'react-router-dom';
import { Create } from './Create';
import { Info } from './Info';
import { Photo } from './Photo';
import { Genres } from './Genres';
import { Accounts } from './Accounts';
import { Identification } from './Identification';
import { Complete } from './Complete';

export default () => (
  <Switch>
    <Route
      path="/signup/artist/create"
      component={Create}
      exact
    />

    <Route
      path="/signup/artist/info"
      component={Info}
      exact
    />

    <Route
      path="/signup/artist/photo"
      component={Photo}
      exact
    />

    <Route
      path="/signup/artist/genres"
      component={Genres}
      exact
    />

    <Route
      path="/signup/artist/accounts"
      component={Accounts}
      exact
    />

    <Route
      path="/signup/artist/identification"
      component={Identification}
      exact
    />

    <Route
      path="/signup/artist/complete"
      component={Complete}
      exact
    />
  </Switch>
);
